module.exports = __webpack_public_path__ + "img/pain_campagne_sliced.8c6a0e5a.jpg";